const styleMap = {
    HIGHLIGHT: {
        padding: '0.25em 0',
        borderRadius: '1.5px',
        background: '#FFEBB0',
    },
    CODE: {
        padding: '0.2em 0.4em',
        background: 'rgba(0,0,0,0.04)',
        borderRadius: '3px',
        fontFamily: 'monospace',
    },
};

export default styleMap;
